module.exports = __webpack_public_path__ + "static/img/104375.1bfaef4d.png";